import {
  SITE_PLATFORM_WEB_LARGE,
  SITE_PLATFORM_WEB,
  SITE_PLATFORM_TABLET,
  SITE_PLATFORM_MOBILE,
} from 'helpers/BreakpointHelper';

const OVERLAY_SHOWS_FILTER = 'OVERLAY_SHOWS_FILTER';
const OVERLAY_MOVIES_FILTER = 'OVERLAY_MOVIES_FILTER';
export const OVERLAY_HEADER_SEARCH = 'OVERLAY_HEADER_SEARCH';
export const OVERLAY_HEADER_DROPDOWN = 'OVERLAY_HEADER_DROPDOWN';
const OVERLAY_SEARCH_FILTER = 'OVERLAY_SEARCH_FILTER';
const OVERLAY_SHOW_DETAIL_TABS = 'OVERLAY_SHOW_DETAIL_TABS';
const OVERLAY_AUTH_MVPD_DIRECT_SIGN_IN_REDIRECT = 'OVERLAY_AUTH_MVPD_DIRECT_SIGN_IN_REDIRECT';
export const OVERLAY_AUTH_MVPD_START = 'OVERLAY_AUTH_MVPD_START';
const OVERLAY_AUTH_MVPD_SEARCH = 'OVERLAY_AUTH_MVPD_SEARCH';
const OVERLAY_AUTH_SUCCESS = 'OVERLAY_AUTH_MVPD_SUCCESS';
const OVERLAY_AUTH_MVPD_IFRAME = 'OVERLAY_AUTH_MVPD_IFRAME';
const OVERLAY_AUTH_UPSELL_CONFIRM = 'OVERLAY_AUTH_UPSELL_CONFIRM';
const OVERLAY_AUTH_UPSELL_ERROR = 'OVERLAY_AUTH_UPSELL_ERROR';
export const OVERLAY_ALL_COLLECTIONS = 'OVERLAY_ALL_COLLECTIONS';
export const OVERLAY_SHOW_SEASONS_TAB = 'OVERLAY_SHOW_SEASONS_TAB';
export const OVERLAY_SHOW_CLIPS_TAB = 'OVERLAY_SHOW_CLIPS_TAB';
export const OVERLAY_SHOW_MORE_TAB = 'OVERLAY_SHOW_MORE_TAB';
export const OVERLAY_LIVE_DATES = 'OVERLAY_LIVE_DATES';
export const OVERLAY_LIVE_NETWORKS = 'OVERLAY_LIVE_NETWORKS';
export const OVERLAY_LIVE_CTA_OVERFLOW = 'OVERLAY_LIVE_CTA_OVERFLOW';
export const OVERLAY_PRIMETIME_DATES = 'OVERLAY_PRIMETIME_DATES';
const OVERLAY_HOME_CTA_OVERFLOW = 'OVERLAY_HOME_CTA_OVERFLOW';
export const OVERLAY_VIDEO_MODAL = 'OVERLAY_VIDEO_MODAL';
const OVERLAY_UPCOMING_DETAIL = 'OVERLAY_UPCOMING_DETAIL';

export const OVERLAY_BREAKPOINTS = {
  [SITE_PLATFORM_WEB_LARGE]: [
    OVERLAY_HEADER_SEARCH,
    OVERLAY_SHOWS_FILTER,
    OVERLAY_MOVIES_FILTER,
    OVERLAY_AUTH_MVPD_DIRECT_SIGN_IN_REDIRECT,
    OVERLAY_AUTH_MVPD_START,
    OVERLAY_AUTH_MVPD_SEARCH,
    OVERLAY_AUTH_MVPD_IFRAME,
    OVERLAY_AUTH_SUCCESS,
    OVERLAY_AUTH_UPSELL_CONFIRM,
    OVERLAY_AUTH_UPSELL_ERROR,
    OVERLAY_ALL_COLLECTIONS,
    OVERLAY_VIDEO_MODAL,
  ],
  [SITE_PLATFORM_WEB]: [
    OVERLAY_HEADER_SEARCH,
    OVERLAY_SHOWS_FILTER,
    OVERLAY_MOVIES_FILTER,
    OVERLAY_AUTH_MVPD_DIRECT_SIGN_IN_REDIRECT,
    OVERLAY_AUTH_MVPD_START,
    OVERLAY_AUTH_MVPD_SEARCH,
    OVERLAY_AUTH_MVPD_IFRAME,
    OVERLAY_AUTH_SUCCESS,
    OVERLAY_AUTH_UPSELL_CONFIRM,
    OVERLAY_AUTH_UPSELL_ERROR,
    OVERLAY_ALL_COLLECTIONS,
    OVERLAY_VIDEO_MODAL,
  ],
  [SITE_PLATFORM_TABLET]: [
    OVERLAY_SHOWS_FILTER,
    OVERLAY_MOVIES_FILTER,
    OVERLAY_HEADER_SEARCH,
    OVERLAY_HEADER_DROPDOWN,
    OVERLAY_SEARCH_FILTER,
    OVERLAY_SHOW_DETAIL_TABS,
    OVERLAY_SHOWS_FILTER,
    OVERLAY_MOVIES_FILTER,
    OVERLAY_AUTH_MVPD_DIRECT_SIGN_IN_REDIRECT,
    OVERLAY_AUTH_MVPD_START,
    OVERLAY_AUTH_MVPD_SEARCH,
    OVERLAY_AUTH_SUCCESS,
    OVERLAY_AUTH_MVPD_IFRAME,
    OVERLAY_AUTH_UPSELL_CONFIRM,
    OVERLAY_AUTH_UPSELL_ERROR,
    OVERLAY_ALL_COLLECTIONS,
    OVERLAY_SHOW_SEASONS_TAB,
    OVERLAY_SHOW_CLIPS_TAB,
    OVERLAY_SHOW_MORE_TAB,
    OVERLAY_LIVE_DATES,
    OVERLAY_LIVE_NETWORKS,
    OVERLAY_LIVE_CTA_OVERFLOW,
    OVERLAY_PRIMETIME_DATES,
    OVERLAY_VIDEO_MODAL,
    OVERLAY_UPCOMING_DETAIL,
  ],
  [SITE_PLATFORM_MOBILE]: [
    OVERLAY_SHOWS_FILTER,
    OVERLAY_MOVIES_FILTER,
    OVERLAY_HEADER_SEARCH,
    OVERLAY_HEADER_DROPDOWN,
    OVERLAY_SEARCH_FILTER,
    OVERLAY_SHOW_DETAIL_TABS,
    OVERLAY_SHOWS_FILTER,
    OVERLAY_MOVIES_FILTER,
    OVERLAY_AUTH_MVPD_DIRECT_SIGN_IN_REDIRECT,
    OVERLAY_AUTH_MVPD_START,
    OVERLAY_AUTH_MVPD_SEARCH,
    OVERLAY_AUTH_SUCCESS,
    OVERLAY_AUTH_MVPD_IFRAME,
    OVERLAY_AUTH_UPSELL_CONFIRM,
    OVERLAY_AUTH_UPSELL_ERROR,
    OVERLAY_ALL_COLLECTIONS,
    OVERLAY_SHOW_SEASONS_TAB,
    OVERLAY_SHOW_CLIPS_TAB,
    OVERLAY_SHOW_MORE_TAB,
    OVERLAY_LIVE_DATES,
    OVERLAY_LIVE_NETWORKS,
    OVERLAY_LIVE_CTA_OVERFLOW,
    OVERLAY_PRIMETIME_DATES,
    OVERLAY_HOME_CTA_OVERFLOW,
    OVERLAY_VIDEO_MODAL,
    OVERLAY_UPCOMING_DETAIL,
  ],
};
